var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shop_svg__rwqlvk3koa)",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.46 6.82H7.5v2.5h1v-2.5h7v2.5h1v-2.5h3.041l.643 7.5h1.004l-.65-7.585a.995.995 0 00-.997-.915h-3.04v-1c0-2.48-2.02-4.5-4.5-4.5a4.505 4.505 0 00-4.5 4.5v1H4.458a.995.995 0 00-.996.915L2.095 22.692A1.503 1.503 0 003.59 24.32H13v-1H3.59a.497.497 0 01-.498-.543l.167-1.957H13v-1H3.345l1.114-13zm4.04-2c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v1h-7v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.354 15.469l-.707.707 3.146 3.146H15v1h6.793l-3.146 3.147.707.707 4.353-4.354-4.354-4.353z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shop_svg__rwqlvk3koa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .32)",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgShop;